import * as yup from 'yup';
import { useField, useForm } from 'vee-validate';
import { isValidPhoneNumber } from 'libphonenumber-js';

const MESSAGES = {
	nameReq: 'Введите имя',
	phoneReq: 'Введите телефон',
	phoneInvalid: 'Номер введен некорректно',
	emailReq: 'Введите email'
};

const validationSchema = yup.object({
	name: yup.string().required(MESSAGES.nameReq).typeError(MESSAGES.nameReq),
	phone: yup
		.string()
		.required(MESSAGES.phoneReq)
		.test('phone', MESSAGES.phoneInvalid, (value: any) => {
			return isValidPhoneNumber(value, 'RU');
		}),
	email: yup.string().email(MESSAGES.emailReq).required(MESSAGES.emailReq),
	check: yup.boolean().required()
});

export function useFeedbackForm() {
	const { handleSubmit, meta, handleReset } = useForm({ validationSchema });

	const nameField = useField<string>('name');
	const phoneField = useField<string>('phone');
	const emailField = useField<string>('email');
	const checkField = useField<boolean>('check');

	const canSubmit = computed(() => {
		if (!meta?.value?.dirty) return true;
		return meta?.value?.valid;
	});

	return {
		nameField,
		phoneField,
		emailField,
		checkField,
		handleSubmit,
		canSubmit,
		handleReset
	};
}
